import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVertical, Mail } from "lucide-react";
import { SendWelcomeEmailModal } from "./SendWelcomeEmailModal";

interface EmployeeActionsMenuProps {
  userId: string;
  employeeName: string;
  employeeEmail: string;
}

export const EmployeeActionsMenu: React.FC<EmployeeActionsMenuProps> = ({
  userId,
  employeeName,
  employeeEmail,
}) => {
  const [isWelcomeEmailModalOpen, setIsWelcomeEmailModalOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 w-8 p-0">
            <MoreVertical className="h-4 w-4" />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem
            onClick={() => setIsWelcomeEmailModalOpen(true)}
            className="cursor-pointer"
          >
            <Mail className="mr-2 h-4 w-4" />
            Send Welcome Email
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <SendWelcomeEmailModal
        isOpen={isWelcomeEmailModalOpen}
        onClose={() => setIsWelcomeEmailModalOpen(false)}
        userId={userId}
        employeeName={employeeName}
        employeeEmail={employeeEmail}
      />
    </>
  );
};
